module.exports = __webpack_public_path__ + "static/media/3_mm_picture_for_legend.811aab21.png";